import { render, staticRenderFns } from "./EditSimpleArticleLoader.vue?vue&type=template&id=07f8858c"
import script from "./EditSimpleArticleLoader.vue?vue&type=script&lang=ts"
export * from "./EditSimpleArticleLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports